<template>
  <div id="couponrange">
    <div class="coupon_nav">
      <div class="coupon_title">礼券</div>
      <div class="coupon_all"
           @click="openPop">查看全部</div>
      <div class="coupon_sign"></div>
    </div>
    <div class="pick_coupon"
         v-if="activity_type===0&&couponType">
      <div class="clear"
           @click="deleteCoupon"></div>
      <Coupon :couponInfo="pickCoupon"></Coupon>
    </div>
    <div class="pick_coupon"
         v-else>
      <div>
        <div class="empty_img">
          <img :src="empty"
               alt />
        </div>
        <div class="empty_text">未使用礼券</div>
      </div>
    </div>
    <CouponMore v-if="popState"
                ref="mychild"
                @useCoupon="changeCoupon"
                :morePickId="pickCoupon"
                :moreCoupon="moreCoupon"></CouponMore>
  </div>
</template>

<script>
import Coupon from '@/components/Coupon'
import CouponMore from '@/components/CouponMore'
import api from '@/api'
import moment from 'moment'
export default {
  props: {
    goodsid: Array,
    playBackList: String,
    unionId: Number
  },
  data () {
    return {
      test: 999,
      couponType: '', //
      pickCoupon: {
        couponType: '',
        price: 0,
        date: '',
        title: '',
        warnState: 1,
        pickType: 1,
        pickId: 0,
        couponState: 1
      },
      activity_type: 0,
      page: 1,
      pageSize: 100,
      popState: false,
      empty: require('@/assets/img/coupon/pick_empty.png'),
      couponPrice: '',
      moreCoupon: []
    }
  },
  // inject: ['provObj'],
  components: {
    Coupon,
    CouponMore
  },
  methods: {
    openPop () {
      this.popState = !this.popState
    },
    // 删除优惠券
    deleteCoupon () {
      this.couponType = ''
      this.pickCoupon = {}
      this.pickCoupon.pickId = 0
      this.pickCoupon.price = 0
      this.$emit('getPrice')
    },
    changeCoupon (e) {
      this.openPop()
      if (e) {
        this.pickCoupon = JSON.parse(JSON.stringify(e))
        this.couponType = 'confirm'
        this.pickCoupon.warnState = 1
        this.pickCoupon.pickType = 1
      } else {
      }
    },
    // 处理有效优惠券 并排序
    handleCoupon (obj) {
      const effective = []
      const invalid = []
      const orderState = this.activity_type
      for (let i = 0; i < obj.length; i++) {
        if (orderState === 0 || orderState === 2) {
          if (obj[i].disable === true) {
            obj[i].couponPower = 1
          } else {
            obj[i].couponPower = 0
          }
        } else {
          obj[i].couponPower = 0
        }
      }
      for (let t = 0; t < obj.length; t++) {
        if (obj[t].couponPower === 1) {
          effective.push(obj[t])
        } else if (obj[t].couponPower === 0) {
          invalid.push(obj[t])
        }
      }
      effective.sort(function (a, b) {
        return b.coupon_val - a.coupon_val
      })
      const arr = effective.concat(invalid)
      return arr
    },
    getCoupon () {
      const params = {
        state: 1,
        course_belong: '质心灵动量',
        page: this.page,
        page_size: this.pageSize,
        goods_ids: String(this.goodsid.join(','))
      }
      const offlineReplay = []
      this.goodsid.forEach(item => {
        var obj = {}
        obj.goods_id = String(item)
        if (this.$route && this.$route.params.playBackList) {
          this.$route.params.playBackList.split(',').forEach(play => {
            obj.offline_replay = item === Number(play) ? 1 : 0
          })
        } else if (this.playBackList) {
          this.playBackList.split(',').forEach(play => {
            obj.offline_replay = item === Number(play) ? 1 : 0
          })
        } else {
          obj.offline_replay = 0
        }
        if (this.unionId) {
          obj.activity_id = this.unionId
          obj.activity_type = 2
        }
        offlineReplay.push(obj)
      })
      params.offline_replay = JSON.stringify(offlineReplay)
      //
      api
        .getCoupon(params)
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data.list
            if (!item) {
              this.$emit(
                'getPrice'
              )
              return false
            } else if (item && item.length === 0) {
              this.$emit(
                'getPrice'
              )
              return false
            }
            const handleData = this.handleCoupon(item)
            const arr = handleData[0]
            this.moreCoupon = handleData
            if (arr.couponPower === 0) {
              this.couponType = ''
            } else if (arr.couponPower === 1) {
              this.couponType = 'confirm'
              this.pickCoupon.couponType = 'confirm'
              this.pickCoupon.couponState = 0
              this.pickCoupon.warnState = 1
              this.pickCoupon.date =
                moment.unix(arr.start_time).format('YYYY.MM.DD') +
                '-' +
                moment.unix(arr.end_time).format('YYYY.MM.DD')
              this.pickCoupon.title = arr.title.slice(0, 12)
              if (arr.all_course) {
                if (arr.goods_type === 5) {
                  this.pickCoupon.warn = '适用范围：' + '面授课中，全部课程可用'
                } else if (arr.goods_type === 2) {
                  this.pickCoupon.warn = '适用范围：' + '直播课中，全部课程可用'
                }
              } else {
                if (arr.goods_type === 5) {
                  this.pickCoupon.warn = '适用范围：面授课中，' + arr.course_fullname + '可用'
                } else if (arr.goods_type === 2) {
                  this.pickCoupon.warn = '适用范围：直播课中，' + arr.course_fullname + '可用'
                }
              }
              this.pickCoupon.pickType = 1
              this.pickCoupon.pickId = arr.coupon_id
              this.pickCoupon.price = arr.coupon_val / 100
            }
            this.$emit(
              'getPrice'
            )
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    }
  },
  watch: {
    goodsid () {
      this.getCoupon()
    }
  },
  created () {
    this.activity_type = this.$route ? Number(this.$route.params.activity_type) : 0
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/_base.scss";
#couponrange {
  background: white;
  .coupon_nav {
    display: flex;
    align-items: center;
    height: 16px;
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 15px;
    .coupon_title {
      font-size: 16px;
      line-height: 16px;
      padding-left: 8px;
      border-left: 2px solid #00c7bf;
      font-family: $family;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .coupon_all {
      font-size: 14px;
      color: rgba(51, 51, 51, 0.6);
      margin: 0px 6px 0px 16px;
      cursor: pointer;
    }
    .coupon_sign {
      width: 16px;
      height: 12px;
      background: url("../assets/img/coupon/pick_empty.png") no-repeat;
      background: url("../assets/img/coupon/liquan.svg") no-repeat;
      background-size: 100% 100%;
    }
  }
  .pick_coupon {
    height: 164px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    display: flex;
    align-items: center;
    padding-left: 32px;
    box-sizing: border-box;
    margin-bottom: 24px;
    position: relative;
    .clear {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: url("../assets/img/coupon/clear.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 22px;
      left: 315px;
      z-index: 2;
      cursor: pointer;
    }
    #coupon {
      .coupon_content {
        .coupon_info {
          .coupon_infoup {
            margin-top: 0px !important;
          }
          .coupon_button {
            display: none;
          }
        }
      }
    }
    .empty_img {
      text-align: center;
    }
    .empty_text {
      color: rgba(51, 51, 51, 0.4);
      font-size: 14px;
    }
  }
}
</style>
